import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { ProgramaItem } from '@/app/models/interface/programa.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class ProgramaItemService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'programa-item/';

  update(id: string, data: Partial<ProgramaItem>) {
    const dir = this.url + id;
    return this.http.put<CustomResponse<ProgramaItem>>(dir, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => data.result),
    );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<
        CustomResponse<PaginatorModel<ProgramaItem[], HasPagination>>
      >(this.url, { params })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => data.result),
      );
  }

  findFaltantes(params?: HttpParams) {
    const dir = this.url + 'faltantes/find/faltantes';
    return this.http
      .get<CustomResponse<{ total: number; faltantes: number }>>(dir, {
        params,
      })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => data.result),
      );
  }

  findTotales(params?: HttpParams) {
    const dir = this.url + 'faltantes/find/totales';
    return this.http
      .get<CustomResponse<{ total: number; faltantes: number }>>(dir, {
        params,
      })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => data.result),
      );
  }

  findRealizados(params?: HttpParams) {
    const dir = this.url + 'faltantes/find/realizados';
    return this.http
      .get<CustomResponse<{ total: number; faltantes: number }>>(dir, {
        params,
      })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => data.result),
      );
  }

  findOne(programaId: string) {
    const url = this.url + programaId;
    return this.http.get<CustomResponse<ProgramaItem>>(url).pipe(
      catchError((err) => handleError(err)),
      map(({ result }) => ({
        ...result,
        capacitacion: {
          ...result.capacitacion,
          actividades:
            result.capacitacion.actividadCompetenciaCapacitaciones?.map(
              (acc) => acc.actividad,
            ) || [],
          areas:
            result.capacitacion.areaCapacitaciones?.map((ac) => ({
              ...ac.area,
              tiempoEnMin: ac.tiempoEnMin,
            })) || [],
        },
      })),
    );
  }
}
